// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PlanPerProjectCostSummary  {
    _originalTypeClassName = "Loom.BO.PlanPerProjectCostSummary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PlanPerProjectCostSummary.translate = translateService;
}
this.AssignedResources = [];
this.Id = null;
this.PrePeriodTSDeclaredEffort = null;
this.PrePeriodTSDeclaredCost = null;
this.PrePeriodTargetEffort = null;
this.PrePeriodTargetCost = null;
this.PrePeriodEffortUtilization = null;
this.PrePeriodCostUtilization = null;
this.PostPeriodTotalEffort = null;
this.PostPeriodTotalCost = null;
this.PostPeriodTargetEffort = null;
this.PostPeriodTargetCost = null;
this.PostPeriodEffortUtilization = null;
this.PostPeriodCostUtilization = null;
this.PeriodEffortInDays = null;
this.PeriodEffortInPMs = null;
this.PeriodTotalCost = null;
this.PeriodTargetEffortInPMs = null;
this.PeriodTargetCost = null;
this.PeriodEffortUtilization = null;
this.PeriodCostUtilization = null;
this.ProjectProgressUntilEndOfPeriod = null;
this.GAEffortInDays = null;
this.GAEffortInPMs = null;
this.GAPersonnelCosts = null;
this.DeclaredPMRate = null;
this.CalculatedPMRate = null;
this.DifferencePMRate = null;
this.GAEffortUtilization = null;
this.GACostUtilization = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
PrePeriodTSDeclaredEffort:any;
PrePeriodTSDeclaredCost:any;
PrePeriodTargetEffort:any;
PrePeriodTargetCost:any;
PrePeriodEffortUtilization:any;
PrePeriodCostUtilization:any;
PostPeriodTotalEffort:any;
PostPeriodTotalCost:any;
PostPeriodTargetEffort:any;
PostPeriodTargetCost:any;
PostPeriodEffortUtilization:any;
PostPeriodCostUtilization:any;
PeriodEffortInDays:any;
PeriodEffortInPMs:any;
PeriodTotalCost:any;
PeriodTargetEffortInPMs:any;
PeriodTargetCost:any;
PeriodEffortUtilization:any;
PeriodCostUtilization:any;
ProjectProgressUntilEndOfPeriod:any;
GAEffortInDays:any;
GAEffortInPMs:any;
GAPersonnelCosts:any;
DeclaredPMRate:any;
CalculatedPMRate:any;
DifferencePMRate:any;
GAEffortUtilization:any;
GACostUtilization:any;
Project:any;
Plan:any;
AssignedResources:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setPlan = ($this, value) => {
var oldValue = $this.Plan;
$this.Plan = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectPlan.removePlanPerProjectCosts(oldValue, $this);
}
Domain.ProjectPlan.addPlanPerProjectCosts(value, $this);
}
}
static setAssignedResources = ($this, items) => {
                if (items == null) items = [];
                if ($this.AssignedResources == null) $this.AssignedResources = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AssignedResources.length > 0) {
                    Domain.PlanPerProjectCostSummary.removeAssignedResources($this, $this.AssignedResources[0]);
                }

                Domain.PlanPerProjectCostSummary.addManyAssignedResources($this, copyItems);
            }
static addManyAssignedResources = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PlanPerProjectCostSummary.addAssignedResources($this, items[i]);
                }
            }
static addAssignedResources = ($this, item) => {
                if ($this.AssignedResources == null) $this.AssignedResources = [];
                if (item == null || $this.AssignedResources.indexOf(item) > -1) return;
                $this.AssignedResources.push(item);
if (item.PlanPerProjectCostSummary != $this) {
Domain.AssignedResource.setPlanPerProjectCostSummary(item, $this);
}
}
static addRangeAssignedResources = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PlanPerProjectCostSummary.addAssignedResources($this, item));
            }
static removeAssignedResources = ($this, item) => {
                if ($this == null || $this.AssignedResources == null || $this.AssignedResources.indexOf(item) === -1) return;
                var _index = $this.AssignedResources.indexOf(item);
                $this.AssignedResources.splice(_index, 1);
item.PlanPerProjectCostSummary = null;
}
static clearAssignedResources = ($this) => { $this.AssignedResources = null; }

static CalculateCosts($this: any): any{for (let _iresource = 0; _iresource < ($this?.AssignedResources == null ? 0 : $this?.AssignedResources.length); _iresource++) {let resource = $this?.AssignedResources[_iresource];Domain.AssignedResource.CalculateCost(resource);}
let assignedPeople = $this?.AssignedResources;
$this.PeriodTotalCost = assignedPeople?.linq?.sum((a) => a?.Cost);
$this.PeriodEffortInDays = assignedPeople?.linq?.sum((a) => a?.AllocatedEffortDays);
$this.PeriodEffortInPMs = Joove.Common.safeNumber($this?.PeriodEffortInDays) * Joove.Common.safeNumber(8) / Joove.Common.safeNumber(143.3);
let workingHours = 8.0;
let participation = $this?.Project?.Consortium?.linq?.where((a) => CLMS.Framework.Number.Equal(() => a.Organisation.Id, () => $this.Plan.Organisation.Id))?.firstOrDefault(null);
$this.GAPersonnelCosts = participation?.PersonnelCosts;
$this.GAEffortInPMs = participation?.TotalEffort;
$this.GAEffortInDays = Joove.Common.safeNumber($this?.GAEffortInPMs) / Joove.Common.safeNumber(workingHours);
if ((CLMS.Framework.Number.GreaterThan(() => assignedPeople.length, () => 0))) {$this.CalculatedPMRate = Joove.Common.safeNumber(assignedPeople?.linq?.sum((a) => a?.PMRate)) / Joove.Common.safeNumber(assignedPeople?.length);}else {$this.CalculatedPMRate = 0;}
$this.PostPeriodTotalEffort = Joove.Common.safeNumber($this?.PrePeriodTSDeclaredEffort) + Joove.Common.safeNumber($this?.PeriodEffortInPMs);
$this.PostPeriodTotalCost = Joove.Common.safeNumber($this?.PrePeriodTSDeclaredCost) + Joove.Common.safeNumber($this?.PeriodTotalCost);
$this.PostPeriodTargetEffort = Joove.Common.safeNumber($this?.PrePeriodTargetEffort) + Joove.Common.safeNumber($this?.PeriodTargetEffortInPMs);
$this.PostPeriodTargetCost = Joove.Common.safeNumber($this?.PrePeriodTargetCost) + Joove.Common.safeNumber($this?.PeriodTargetCost);
}
static GetDifferencePMRate($this: any): any{return Joove.Common.safeNumber($this?.CalculatedPMRate) - Joove.Common.safeNumber($this?.DeclaredPMRate);
}
static GetGACostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.GAPersonnelCosts, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalCost) / Joove.Common.safeNumber($this?.GAPersonnelCosts), 2);
}
static GetGAEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.GAEffortInPMs, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalEffort) / Joove.Common.safeNumber($this?.GAEffortInPMs), 2);
}
static GetPeriodCostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PeriodTargetCost, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PeriodTotalCost) / Joove.Common.safeNumber($this?.PeriodTargetCost), 2);
}
static GetPeriodEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PeriodTargetEffortInPMs, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PeriodEffortInPMs) / Joove.Common.safeNumber($this?.PeriodTargetEffortInPMs), 2);
}
static GetPostPeriodCostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PostPeriodTargetCost, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalCost) / Joove.Common.safeNumber($this?.PostPeriodTargetCost), 2);
}
static GetPostPeriodEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PostPeriodTargetEffort, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PostPeriodTotalEffort) / Joove.Common.safeNumber($this?.PostPeriodTargetEffort), 2);
}
static GetPrePeriodCostUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PrePeriodTargetCost, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PrePeriodTSDeclaredCost) / Joove.Common.safeNumber($this?.PrePeriodTargetCost), 2);
}
static GetPrePeriodEffortUtilization($this: any): any{if ((CLMS.Framework.Number.LessThanOrEqual(() => $this.PrePeriodTargetEffort, () => 0))) {return 0;}
return Joove.Common.mathRound(Joove.Common.safeNumber($this?.PrePeriodTSDeclaredEffort) / Joove.Common.safeNumber($this?.PrePeriodTargetEffort), 2);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}